// export const data = {
//     evn: 'http://localhost:8052' 
// };

export const data = {
    evn: 'https://api.lawfaxai.com'
};